<template>
  <form @submit.prevent="saveClassHandler">
    <div class="save-class modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">Schedule A Class</p>
      </header>
      <section class="save-class__container modal-card-body">
        <b-loading v-if="classes.submitting" active :is-full-page="false" />
        <b-field label="Schedule at">
          <datetime
            v-model="selectedScheduledAt"
            auto
            input-class="input"
            type="datetime"
            use12-hour
            :min-datetime="nowISOString"
          />
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <b-button
          :loading="classes.submitting"
          class="button is-primary"
          native-type="submit"
        >
          Schedule
        </b-button>
      </footer>
    </div>
  </form>
</template>

<script>
import Datetime from '../../../ui/general/DateTime';
import { Timestamp } from '../../../firebase';
import { mapActions, mapState } from 'vuex';

const SaveClassModal = {
  data() {
    return {
      selectedChallenge: '',
      selectedScheduledAt: this.scheduledAt
    };
  },
  props: {
    challengeId: {
      required: false
    },
    classId: {
      required: false
    },
    userId: {
      required: false
    },
    scheduledAt: {
      type: Timestamp,
      default: Timestamp.now
    }
  },
  computed: {
    ...mapState(['classes']),
    nowISOString() {
      return new Date().toISOString();
    }
  },
  methods: {
    ...mapActions('classes', ['addClass', 'updateClass']),
    async saveClassHandler() {
      const scheduledAt = this.selectedScheduledAt.toDate().toISOString();
      try {
        const result = this.classId
          ? await this.updateClass({
              classId: this.classId,
              scheduledAt
            })
          : await this.addClass({
              userId: this.userId,
              challengeId: this.challengeId || this.selectedChallenge.id,
              scheduledAt
            });
        this.$emit('input', result);
        this.$buefy.toast.open('Class saved successfully!');
      } catch (e) {
        this.$buefy.toast.open({
          message: this.parseClassError(e),
          type: 'is-danger'
        });
      } finally {
        this.close();
      }
    },
    parseClassError(error) {
      switch (error.message) {
        case 'challenge_already_scheduled':
          return 'This Challenge was already scheduled for this user!';
        case 'no_classes_remaining':
          return 'The User does not have credits in his account to assign classes!';
        default:
          return 'Failed to update classes';
      }
    },
    close() {
      this.$emit('close');
    }
  },
  components: {
    Datetime
  }
};

export default SaveClassModal;

export function createClass(parent, userId, challengeId) {
  if (!userId) throw Error('No UserId!!');
  return new Promise((resolve, reject) => {
    parent.$buefy.modal.open({
      parent,
      component: SaveClassModal,
      hasModalCard: true,
      props: {
        userId,
        challengeId
      },
      events: {
        input: resolve
      },
      onCancel: reject
    });
  });
}

export function updateClass(parent, scheduledClass) {
  if (!scheduledClass) throw Error('No scheduledClass!!');
  return new Promise((resolve, reject) => {
    parent.$buefy.modal.open({
      parent,
      component: SaveClassModal,
      hasModalCard: true,
      props: {
        classId: scheduledClass.id,
        scheduledAt: scheduledClass.scheduledAt
      },
      events: {
        input: resolve
      },
      onCancel: reject
    });
  });
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins.sass';

.save-class {
  width: auto;

  &__container {
    min-width: 20rem;
    max-width: 33.6rem;
    .button.is-medium {
      font-size: 1rem;
      margin: 0 0 0.1rem 0.1rem;
    }
    @include tablet {
      min-width: 20rem;
    }
  }
}
</style>
